
<template>
  <div>
      <div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Fawry Payment </a></h1>

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Payment list </div>
<div class="panal-body " >
    <div class="table table-responsive col-md-10 m-auto">
        <table  id="ChargesTable" border="1"  class="tabel" width="100%">
            <thead>
                <tr class="text-uppercase jumbotron" style="text-transform:capitalize">
                    
                    <th align="center" class="text-center"><strong>Payment Name</strong></th>
                    <th align="center" class="text-center"><strong>Value</strong></th>
                </tr>
            </thead>

            <tbody class="text-center" id="ChargesTableData">
                <tr v-for="(data,index) in ChargesTableData" v-bind:key="index">
                   
                    <td>{{data.Description}}
                    </td>
                   
                    <td>{{data.Price}}
                    </td>
                   
                    </tr>
                   
            </tbody>
            <tfoot></tfoot>
        </table>
        </div>
        <p class="mt-50 alert alert-warning">  Please Review your payment List Carefully then Press the Fawy Icon </p>
            <div class="text-center"><input type="image" class="mt-50" @click="GetMerchantRefNumber" src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png" alt="Edfa3 Fawry" id="xsrrs" />
            </div> </div>
    
    
  </div>
</div>
</div>
      </div>
  </div>
  
</template>

<script>
//import  $  from 'jquery';
import { API_URL } from '../../services/API_URL';
import Axios from 'axios';
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
export default {
    

   data(){
       return{
         URL : '',
         Startindex : '',
         Endindex : '',
        res : '',
        chargeRequest :{},
        BackMerchantRefNumber:'',
        BackFawryRefNumber:'',
        BackPaymentMethod:'',
        ChargesTableData:[],
        SelectedList:[],
        SentPayemtList: [],
        newURL:'',
        FinalList :[]
       }
   },
   created() {
              if(this.PaymentStore.length == 0 ) this.$router.push('/wallet')

     var scripts = [
     // "https://www.atfawry.com/ECommercePlugin/scripts/V2/FawryPay.js", // for live version 
      "https://atfawry.fawrystaging.com/atfawry/plugin/assets/payments/js/fawrypay-payments.js", // for testing
    ];

    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      tag.defer =true
      document.head.appendChild(tag);
    });
       
  },
   mounted(){
        this.URL = document.URL;
         this.Startindex = this.URL.indexOf("?");
         this.Endindex = this.URL.indexOf('%7D');
         if (this.Endindex >0 ){

              this.newURL = this.URL

            this.res = this.URL.slice(this.Startindex + 1, this.Endindex+3);
            if (this.Startindex > 0){
            for (let i = 0; i < this.Endindex; i++) {
                this.res = this.res.replace("%3A", ':');
                this.res = this.res.replace("%7B", '{');
                this.res = this.res.replace("%7D", '}');
                this.res = this.res.replace("%22", '"');
            }

             this.res = this.res.toString()
             this.Startindex = this.res.indexOf("{");
             this.Endindex = this.res.indexOf("}");

             this.res = this.res.slice(this.Startindex, this.Endindex + 1);
            let  obj = JSON.parse(this.res);
              this.BackMerchantRefNumber = obj.merchantRefNumber
             this.BackFawryRefNumber = obj.fawryRefNumber
             this. BackPaymentMethod = obj.paymentMethod


             if(this.BackFawryRefNumber != "" && this.BackFawryRefNumber != null && this.BackFawryRefNumber != 'undefined' ){
                this.GetStatus()
                 this.$router.push('/wallet')
                
             }else{
                 this.$router.push('/wallet')
             }
        }else{
         this.$router.push('/wallet')

        }
         }
       
        this.ApplicantFawryCharges()
        this.chargeRequest.language = 'en-gb';
		this.chargeRequest.merchantCode = '1tSa6uxz2nQTr1zLVX3aaA==';   // for tesing 
		//this.chargeRequest.merchantCode = 'rfM9nzFIxkxoFWvyDKW6mA=='; // for live verion 
		this.chargeRequest.customer = {}
		this.chargeRequest.customer.name = this.currentUser.Username; // Applicant name 
		this.chargeRequest.customer.mobile = '';
		this.chargeRequest.customer.email = '';
		this.chargeRequest.customer.customerProfileId = this.currentUser.UserIDSerial; //ApplicantID
   },
   methods:
   {
ApplicantFawryCharges(){
  
            this.ChargesTableData = this.PaymentStore
 
            
       
},

    GetMerchantRefNumber(){

     Axios.post(API_URL + `CreateApplication/GetMerchantRefNumber?ApplicantID=${ this.currentUser.UserIDSerial}`, this.PaymentStore)
    .then(result => {
               
            this.chargeRequest.merchantRefNumber = result.data;
            this.GenerateCheckoutSignature();
        }).catch(error=>{
            alert("Error occured!! "+ error)
        })
            
},

    GenerateCheckoutSignature(){
   
    Axios.post(API_URL + `CreateApplication/GenerateCheckoutSignature?MerchantRefNumber=${this.chargeRequest.merchantRefNumber}&ApplicantID=${this.currentUser.UserIDSerial}`,this.PaymentStore)
    .then(result => {
        this.chargeRequest.signature =result.data;
   var products = [];
    this.chargeRequest.order = {}
    this.chargeRequest.order.orderItems = [];
    this.chargeRequest.order.description = '';
 
     this.PaymentStore.forEach(element => {
         var product = {};
        product.productSKU  = element.ProductSKU;
        product.description = element.Description;
        product.quantity    = element.Quantity;
        product.price       = element.Price;
        products.push(product);
        ApplicantDataServices.ApplicantRepeatedPaymnet(element.PaymentID).then( response => 
         
        {
        if(response.data == 1) this.$router.push('/wallet')
         })
     this.chargeRequest.order.orderItems.push(product);
       
    });
    this.Fawry();
    
    })
}, 
    GetStatus() {
        Axios.post(API_URL + `CreateApplication/GetPaymentStatus?MerchantRefNumber=${this.BackMerchantRefNumber}&ApplicantID=${this.currentUser.UserIDSerial}`,this.PaymentStore)
         .then(result =>{
                    this.chargeRequest.signature = result.data;
            this.$store.dispatch('auth/Review', this.reviewApplication+1 )

    })
},

//     requestCanceldCallBack(merchantRefNum) {
//     // Your implementation to handle the calncel button
// },
//     fawryCallbackFunction(paid, billingAcctNum, paymentAuthId,merchantRefNum, messageSignature) {
//     // Your implementation

//     this.GetStatus();
// },

Fawry() {
    
    
    // eslint-disable-next-line no-undef
    if (FawryPay){
        // eslint-disable-next-line no-undef
        FawryPay.checkout(this.chargeRequest, 'fawry', 'wallet')
    }else{
        //alert('fawry not in window')
    }
    
},


   },
   computed:{
       PaymentStore(){
              return this.$store.state.auth.paymentList
        },
     currentUser() {
        return this.$store.state.auth.user
      },
      reviewApplication(){
       return  this.$store.state.auth.renderReview 
       }
   }

}
</script>

<style>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}
.mt-50{
    margin-top: 50px !important;
}
.m-auto{
    margin: auto !important;
}
</style>